import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-qrcode',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss'],
})
export class QrcodeComponent  implements OnInit {
  public isQRCodeModalOpen: boolean = false;
  public sanitizedQRCode!: SafeHtml;
  public contadorQrCode!: number;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {}

  public openQrCodeModal(qrcode: string): void{
    this.sanitizedQRCode = this.sanitizer.bypassSecurityTrustHtml(qrcode);
    this.contadorQrCode = 20;
    this.isQRCodeModalOpen = true;
    this.regressContador();
  }

  public closeQRCodeModal(){
  this.isQRCodeModalOpen = false;
  this.sanitizedQRCode = '';
  }

  public regressContador() {
    let i = 20; 
  
    const interval = setInterval(() => {
      console.log('Contador:', i);
      this.contadorQrCode = i; 
  
      if (i === 0) {
        clearInterval(interval); 
        this.closeQRCodeModal(); 
      }
  
      i--; 
    }, 1000); 
  }

}
